import store from '@carvana/purchase-store';

const Experiments = {
  list: [],
  addExperiment(experiment) {
    if (!experiment) return this;
    const newExperiment = {
      experimentKey: experiment?.experimentName,
      bucketKey: experiment?.assignedBucket
    };
    this.list.push(newExperiment);
    this.removeDuplicates();
    return this;
  },
  addExperimentList(newList) {
    if (!Array.isArray(newList)) return this;
    this.list = [...newList, ...this.list];
    this.removeDuplicates();
    return this;
  },
  initialize() {
    const { core: { experiments = [] } = {} } = store.getState();
    this.list = this.addExperimentList(experiments).list;
    return this;
  },
  removeDuplicates() {
    this.list = this.list.reduce((unique, experiment) => {
      if (!unique.some(obj => obj.experimentKey === experiment.experimentKey)) {
        unique.push(experiment);
      }

      return unique;
    }, []);
    return this;
  },
  toObject(allExperiments) {
    return allExperiments.list.reduce((object, experiment) => { return { ...object, [experiment.experimentKey]: experiment.bucketKey }; }, {});
  }
};

export default Experiments;
